module.exports = require("babel-runtime/core-js/object/define-property");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/core-js/object/define-property"
// module id = 22
// module chunks = 0 1 2 3 4 5 6 7 10 11 16 18